window.onscroll = function changeClass() {
    let scrollPosY = window.pageYOffset | document.body.scrollTop;
    // get first nav element
    let navBar = document.getElementById("navbar");

    // var secondSection = document.getElementById("secondSection"); // selects the element by Id.
    // var secondSectionTop = aboutSection.getBoundingClientRect().top; //selects the Y position of the element in the view
    // var navBarHeight = navBar.getBoundingClientRect().height; //select the height of the navBar
    const overlayClasses = ["xl:py-4", "shadow-md"];
    const defaultClasses = "xl:py-8";

    if (scrollPosY > 100) {
        navBar.classList.add(...overlayClasses);
        navBar.classList.remove(defaultClasses);
    } else if (scrollPosY <= 100) {
        navBar.classList.add(defaultClasses);
        navBar.classList.remove(...overlayClasses);
    }
};
